module.exports = __webpack_public_path__ + "static/pco-71e40e85b7c1c3b0ce323c0159610a24.jpg";